export enum PolymorphicDeserializationKey {
  Menu,
  Section,
  Label,
  Display,
  WebSocketMessage
}
